"use client"

import type { DroppedItem } from "@/types/item.types"
import { RadialMenu, type RadialMenuOption } from "@/components/ui/radial-menu"

interface DroppedItemMenuProps {
  droppedItem: DroppedItem
  screenPosition: { x: number; y: number }
  canPickup: boolean
  onPickup: () => void
  onDestroy: () => void
  onClose: () => void
}

// Simple icon components
const PickupIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 19V5" />
    <path d="M5 12l7-7 7 7" />
  </svg>
)

const DestroyIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6L6 18" />
    <path d="M6 6l12 12" />
  </svg>
)

export const DroppedItemMenu = ({
  screenPosition,
  canPickup,
  onPickup,
  onDestroy,
  onClose,
}: DroppedItemMenuProps) => {
  const options: RadialMenuOption[] = [
    {
      id: "pickup",
      icon: <PickupIcon />,
      label: "Pick Up",
      disabled: !canPickup,
      onClick: () => {
        if (canPickup) {
          onPickup()
          onClose()
        }
      },
    },
    {
      id: "destroy",
      icon: <DestroyIcon />,
      label: "Destroy",
      onClick: () => {
        onDestroy()
        onClose()
      },
    },
  ]

  return (
    <RadialMenu
      position={screenPosition}
      options={options}
      radius={50}
      iconSize={40}
      onClose={onClose}
    />
  )
}
